import {Fragment, useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';

import {OrderList} from '../../../components/orderlist/OrderList';

import {TenantInvoiceSettingMasterService} from '../../../he-thong/cau-hinh-hoa-don/TenantInvoiceSettingMasterService';
import {InvoiceSettingDefaultService} from '../../../he-thong/cau-hinh-hoa-don/InvoiceSettingDefaultService';

import {Toolbar} from './Toolbar';
import {OrderForm} from './OrderForm';

export const Menu3 = (props) => {

  const {tenantInvoiceSettingMasterId, invoiceType} = props.attribute;

  const [formId, setFormId] = useState('');
  const [formSetting, setFormSetting] = useState({
    dragdrop: false
  });
  const [groupCode, setGroupCode] = useState('');

  const [fieldId, setFieldId] = useState('');
  const [fieldDeletable, setFieldDeletable] = useState(false);
  const [targetId, setTargetId] = useState('');
  const [targetSetting, setTargetSetting] = useState({});

  const [items, setItems] = useState([]);

  const [invoiceSettings, setInvoiceSettings] = useState(null);

  const [display, setDisplay] = useState(false);
  const [settings, setSettings] = useState([]);
  const [selectedField, setSelectedField] = useState(null);
  const [selectedSetting, setSelectedSetting] = useState(null);

  useEffect(() => {
    if (invoiceSettings && invoiceSettings.length) {
      const event = new CustomEvent('addSelectListener');
      props.dispatchEvent(event);

      const onSelect = (event) => {
        if (event.detail.formId && event.detail.formId !== formId) {
          const {formId, formSetting, groupCode, items} = event.detail;
          setFormId(formId);
          setFormSetting(formSetting);
          setGroupCode(groupCode);
          setItems(items);
        }
      }
      props.preview.current.contentWindow.document.getElementById('template-preview').addEventListener('onSelect', onSelect);
      return () => {
        props.preview.current?.contentWindow.document.getElementById('template-preview').removeEventListener('onSelect', onSelect);
      }
    }
  }, [invoiceSettings]);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if (tenantInvoiceSettingMasterId) {
    //   TenantInvoiceSettingMasterService.get(tenantInvoiceSettingMasterId).then(data => {
    //     setInvoiceSettings(data.invoiceSettings);
    //   });
    // } else {
    //   if (invoiceType && invoiceType.id) {
    //     InvoiceSettingDefaultService.getList({typeInvoiceId: invoiceType.id, maxResultCount: 1000}).then(({items}) => {
    //       setInvoiceSettings(items);
    //     });
    //   }
    // }
    const invoiceData = [
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "amount",
        lable: "Tổng tiền hàng",
        lableWidth: 10,
        controlWidth: 10,
        dataType: "int32",
        required: false,
        maxLength: 27,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "06",
        groupXML: null,
        orders: 1,
        defaultValue: "",
        formula: "SUM ( Cộng tiền hàng )",
        formulaExcel: "SUM ( Cộng tiền hàng )",
        lableExportExcel: "",
        typeFormat: "formatTotal",
        use: true,
        ordersFormula: 1,
        formulas: [
          {
            tenantInvoiceSettingId: null,
            invoiceSettingId: null,
            groupCode: "Form",
            formulaType: null,
            formulaLable: "SUM ( Cộng tiền hàng )",
            formulaFe:
              '[{"value":"SUM","label":"SUM","type":"operator"},{"value":"(","label":"(","type":"operator"},{"value":"3a05524a-a7e4-acc8-e6bb-f45e255b15ab","label":"Cộng tiền hàng","type":"parameter","groupTypeCode":"05","fieldName":"amount"},{"value":")","label":")","type":"operator"}]',
            formulaBe: "SUM ( 05.amount )",
            lastModificationTime: null,
            lastModifierId: null,
            creationTime: "2022-07-27T21:51:03.193849+07:00",
            creatorId: "3a055160-82e7-e5fc-6f86-103c1a0038dc",
            id: "001362d7-e7a6-4f69-b91f-0b97663d199a",
          },
        ],
        formulasExcel: [
          {
            tenantInvoiceSettingId: null,
            invoiceSettingId: null,
            groupCode: "Excel",
            formulaType: null,
            formulaLable: "SUM ( Cộng tiền hàng )",
            formulaFe:
              '[{"value":"SUM","label":"SUM","type":"operator"},{"value":"(","label":"(","type":"operator"},{"value":"3a055283-095f-6aa4-3b91-d2d7b8abf64c","label":"Cộng tiền hàng","type":"parameter","groupTypeCode":"05","fieldName":"amount"},{"value":")","label":")","type":"operator"}]',
            formulaBe: "SUM ( 05.amount )",
            lastModificationTime: null,
            lastModifierId: null,
            creationTime: "2022-07-29T08:55:33.326335+07:00",
            creatorId: "3a055160-82e7-e5fc-6f86-103c1a0038dc",
            id: "71805da1-e06e-42eb-a3fe-2e8115a36486",
          },
        ],
        useFormula: true,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:27:16.911513+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a08801e-93ac-935d-fe65-4869f80017e5",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "invoiceSerial",
        lable: "Ký hiệu",
        lableWidth: 6,
        controlWidth: 6,
        dataType: "string",
        required: true,
        maxLength: 7,
        fomat: null,
        numberItemInLine: 2,
        readOnly: false,
        multipleFormula: false,
        groupTypeCode: "00",
        groupXML: null,
        orders: 1,
        defaultValue: "1C22TYY",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "Ký hiệu",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.693393+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2b0a-c055-23dc-7967d0959c8f",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "buyerTaxCode",
        lable: "Mã số thuế",
        lableWidth: 2,
        controlWidth: 4,
        dataType: "string",
        required: false,
        maxLength: 14,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "02",
        groupXML: null,
        orders: 1,
        defaultValue: "0101123456",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "Mã số thuế bên mua",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.872615+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2bbd-797a-8bed-c2e6bd87ebf9",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "sellerTaxCode",
        lable: "Mã số thuế",
        lableWidth: 2,
        controlWidth: 10,
        dataType: "string",
        required: true,
        maxLength: 14,
        fomat: null,
        numberItemInLine: 2,
        readOnly: false,
        multipleFormula: false,
        groupTypeCode: "01",
        groupXML: null,
        orders: 1,
        defaultValue: null,
        formula: null,
        formulaExcel: null,
        lableExportExcel: "",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.976359+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2c25-f9cd-cf8f-5f11f2800108",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "relatedInvoiceProperty",
        lable: "Tính chất hóa đơn liên quan",
        lableWidth: 2,
        controlWidth: 2,
        dataType: "int32",
        required: true,
        maxLength: 1,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "04",
        groupXML: null,
        orders: 1,
        defaultValue: "",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: true,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.828255+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2b91-93fa-0fbc-9134ad101238",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "ordinalNumber",
        lable: "STT",
        lableWidth: 50,
        controlWidth: 6,
        dataType: "string",
        required: false,
        maxLength: 4,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "05",
        groupXML: null,
        orders: 1,
        defaultValue: "",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:46:59.965562+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088030-a0fa-ff36-c0bc-c29f0f6ba83d",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "productCode",
        lable: "Mã hàng",
        lableWidth: 100,
        controlWidth: 6,
        dataType: "string",
        required: false,
        maxLength: 50,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "05",
        groupXML: null,
        orders: 2,
        defaultValue: "HH001",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "Mã hàng",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:46:59.973572+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088030-a102-9bd3-4f2c-e2539529a826",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "buyerCode",
        lable: "Mã KH",
        lableWidth: 2,
        controlWidth: 4,
        dataType: "string",
        required: false,
        maxLength: 50,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "02",
        groupXML: null,
        orders: 2,
        defaultValue: "KH001",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "Mã khách hàng",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.879181+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2bc4-7a31-cdfa-2072b8293d5c",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "invoiceDate",
        lable: "Ngày hóa đơn",
        lableWidth: 6,
        controlWidth: 6,
        dataType: "datetime",
        required: false,
        maxLength: null,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "00",
        groupXML: null,
        orders: 2,
        defaultValue: "'",
        formula: null,
        formulaExcel: null,
        lableExportExcel: "Ngày hóa đơn",
        typeFormat: null,
        use: true,
        ordersFormula: null,
        formulas: [],
        formulasExcel: [],
        useFormula: false,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:13:43.701866+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a088012-2b13-d526-dcb4-1365ef27c1bd",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
        fieldName: "totalDiscountAmount",
        lable: "Tổng tiền CK",
        lableWidth: 10,
        controlWidth: 10,
        dataType: "int32",
        required: false,
        maxLength: 27,
        fomat: null,
        numberItemInLine: 2,
        readOnly: true,
        multipleFormula: false,
        groupTypeCode: "06",
        groupXML: null,
        orders: 2,
        defaultValue: "",
        formula: "SUM ( Tiền CK )",
        formulaExcel: "SUM ( Tiền CK )",
        lableExportExcel: "",
        typeFormat: "formatTotal",
        use: true,
        ordersFormula: 2,
        formulas: [
          {
            tenantInvoiceSettingId: null,
            invoiceSettingId: null,
            groupCode: "Form",
            formulaType: null,
            formulaLable: "SUM ( Tiền CK )",
            formulaFe:
              '[{"value":"SUM","label":"SUM","type":"operator"},{"value":"(","label":"(","type":"operator"},{"value":"3a05524a-a7f2-020c-74c8-776815e8e018","label":"Tiền CK","type":"parameter","groupTypeCode":"05","fieldName":"discountAmount"},{"value":")","label":")","type":"operator"}]',
            formulaBe: "SUM ( 05.discountAmount )",
            lastModificationTime: null,
            lastModifierId: null,
            creationTime: "2022-07-27T21:51:03.202374+07:00",
            creatorId: "3a055160-82e7-e5fc-6f86-103c1a0038dc",
            id: "dafa0739-db2a-4bcf-879a-915f96f25d0d",
          },
        ],
        formulasExcel: [
          {
            tenantInvoiceSettingId: null,
            invoiceSettingId: null,
            groupCode: "Excel",
            formulaType: null,
            formulaLable: "SUM ( Tiền CK )",
            formulaFe:
              '[{"value":"SUM","label":"SUM","type":"operator"},{"value":"(","label":"(","type":"operator"},{"value":"3a055283-096d-73ad-d26d-2a35168b8e7d","label":"Tiền CK","type":"parameter","groupTypeCode":"05","fieldName":"discountAmount"},{"value":")","label":")","type":"operator"}]',
            formulaBe: "SUM ( 05.discountAmount )",
            lastModificationTime: null,
            lastModifierId: null,
            creationTime: "2022-07-29T08:55:33.336548+07:00",
            creatorId: "3a055160-82e7-e5fc-6f86-103c1a0038dc",
            id: "ab815462-fc4f-4093-a4b8-a4284a7e91d2",
          },
        ],
        useFormula: true,
        isDeleted: false,
        deleterId: null,
        deletionTime: null,
        lastModificationTime: null,
        lastModifierId: null,
        creationTime: "2023-01-01T22:27:16.919981+07:00",
        creatorId: "3a0851d3-2bb1-9a65-02f3-ce5a894297c8",
        id: "3a08801e-93b5-03f4-bb24-97c9b51824a2",
      },
      {
        typeInvoiceId: "fc057613-9499-47f0-bbeb-2181c254c159",
      },
    ];
    setInvoiceSettings(invoiceData);
  }, [tenantInvoiceSettingMasterId, invoiceType]);

  useEffect(() => {
    if (groupCode && invoiceSettings) {
      const _settings = [];
      invoiceSettings.forEach(setting => {
        if (groupCode.includes(setting.groupTypeCode)) {
          _settings.push({value: setting.fieldName, label: setting.lable});
        }
      });
      setSettings(_settings);
    }
  }, [groupCode, invoiceSettings]);

  const selectField = (target) => {
    if (target && target.targetId) {
      setFieldId(target.fieldId);
      setFieldDeletable(target.addedField === 'Y');
      setTargetId(target.targetId);
      setTargetSetting(target.targetSetting);

      // let event = new CustomEvent('setCss', {
      //   detail: {selector: `.chinhSua`, property: 'background', value: ``}
      // });
      // props.dispatchEvent(event);

      // event = new CustomEvent('setCss', {
      //   detail: {selector: `#${target.targetId}`, property: 'background', value: `rgb(179, 230, 247)`}
      // });
      // props.dispatchEvent(event);
    } else {
      setFieldId(null);
      setFieldDeletable(false);
      setTargetId(null);
      setTargetSetting({});

      // let event = new CustomEvent('setCss', {
      //   detail: {selector: `.chinhSua`, property: 'background', value: ``}
      // });
      // props.dispatchEvent(event);
    }
  }

  const onRowReorder = (orderedItems) => {
    setItems(orderedItems);
    let event = new CustomEvent('reorder', {
      detail: {selector: formId, value: orderedItems}
    });
    props.dispatchEvent(event);
  }

  const showEditField = (field) => {
    if (field) {
      setSelectedField(field);
      setDisplay(true);
      if (field.databind) {
        setSelectedSetting(field.databind);
      } else {
        setSelectedSetting(null);
      }
    }
  }

  const onEditFieldSubmit = () => {
    let event;
    switch (selectedField.groupCode) {
      case '05':
        event = new CustomEvent('setAttr', {
          detail: {selector: `#tr-bc4-2 > tr:first-child td:eq(${selectedField.fieldIndex}) > font`, property: 'databind', value: selectedSetting}
        });
        break;
      default:
        event = new CustomEvent('setAttr', {
          detail: {selector: `#${selectedField.valueTarget}`, property: 'databind', value: selectedSetting}
        });
    }
    props.dispatchEvent(event);
    setDisplay(false);

    event = new CustomEvent('loadForm', {
      detail: {selector: formId}
    });
    props.dispatchEvent(event);
  }

  const itemTemplate = (item) => {
    
    item.label = item.label ? item.label.trim() : item.label;
    item.songNgu = item.songNgu ? item.songNgu.trim() : item.songNgu;
    return (
      <OrderForm field={item} selectField={selectField} dispatchEvent={props.dispatchEvent} showEditField={showEditField}/>
    );
  }

  return (
    <Fragment>
      <div className="grid mt-2">
        <div className="col-12 pb-0">
          <Toolbar formId={formId} formSetting={formSetting} fieldId={fieldId} fieldDeletable={fieldDeletable} targetId={targetId} targetSetting={targetSetting}
                   selectField={selectField} dispatchEvent={props.dispatchEvent}/>
        </div>
      </div>
      <hr className="mt-0"/>
      <div className="iam-scroll pt-0 pb-0" style={{height: (props.windowHeight - 373.5) + 'px', overflow: 'hidden auto'}}>
        <div className="grid">
          {invoiceSettings &&
              <div className="col-12">
                {formId
                  ? <Fragment>
                    <OrderList value={items} dragdrop={formSetting.dragdrop} dataKey="fieldId"
                               itemTemplate={itemTemplate} onChange={(e) => onRowReorder(e.value)} className="template-editor-controls"/>
                  </Fragment>
                  : <div className="image-uploader">
                    <i className="pi pi-reply"/>
                    <p>Kích chọn vào một trong các nhóm thông tin trên hóa đơn để thực hiện chỉnh sửa nội dung</p>
                  </div>
                }
              </div>
          }
          {!invoiceSettings &&
              <div className="col-12">
                  <div className="image-uploader">
                      <i className="pi pi-info-circle"/>
                      <p>Bạn chưa chọn cấu hình ở tab Thông tin chung!</p>
                  </div>
              </div>
          }
        </div>
      </div>
      <Dialog header="Chọn trường hiển thị" visible={display} style={{width: '40rem'}} onHide={() => setDisplay(false)} className="no-scroll">
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-12">
            <Dropdown value={selectedSetting} options={settings} onChange={e => setSelectedSetting(e.value)} filter={true}/>
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Lưu" icon="pi pi-check" onClick={onEditFieldSubmit} className="p-button-sm mr-2"/>
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    </Fragment>
  );
}




